import { useQuery } from "@/compat/reactQuery";
import adviceService from "../../services/adviceService";

export default function useAdviceDetails(id) {
    return useQuery(
        ['advice-details', id],
        () => adviceService.fetchAdviceDetails(id),
        {
            enabled: !!id
        }
    );
} 